export default "__VITE_ASSET__DXrH$gd6__"